var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { State, Action, Selector, Store } from '@ngxs/store';
import { BookmarksStateModel } from './bookmarks.state.model';
import { LoadBookmarks, LoadBookmarksSuccess, LoadOrganizationBookmarks, DeleteBookmark, DeleteBookmarkSuccess, SaveBookmark, SaveBookmarkSuccess, SelectBookmark, SelectBookmarkSuccess, SaveBookmarkFail, SaveBookmarkThumbnails, ResetBookmarks, SortBookmarks, CheckBookmark, SetCheckedBookmarks, ExportBookmarks, ExportBookmarksSuccess, ExportBookmarksError, LoadCollectionBookmarks, DeleteBookmarkFail, DeleteFavorite, DeleteFavoriteSuccess, DeleteFavoriteFail, CopyBookmark, CopyBookmarkFailure, CopyBookmarkSuccess, SetBookmarkText, SetSelectedCategory, ClearBookmarks, UpdateBookmarkCollection, UpdateBookmarkCollectionSuccess, UpdateBookmarkCollectionError, RemoveBookmarkCollectionSuccess, AddBookmarkCollectionSuccess, RemoveBookmarkCollectionError, AddBookmarkCollectionError } from './bookmarks.actions';
import { finalize, flatMap, filter, tap, map, toArray } from 'rxjs/operators';
import { BookmarksService } from '../bookmarks.service';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { concat, forkJoin, of } from 'rxjs';
import { RegisterChapterThumbnails } from 'src/app/story/state/chapters/story.chapters.actions';
import { bookmarkSortRecent } from '../components/bookmarks-sort/bookmarks-sort.component';
import { PublishService } from 'src/app/publish/publish.service';
import { WidgetOptions } from 'src/app/publish/models/widget-options.model';
import { OrganizationsService } from 'src/app/organizations/organizations.service';
import { StoryService } from 'src/app/story/story.service';
import { StoryLabelsState } from 'src/app/story/state/labels/story.labels.state';
import { ExploreService } from 'src/app/explore/explore.service';
import { AuthState } from 'src/app/auth/state/auth/auth.state';
import { Thumbnail } from 'src/app/shared/thumbnail-utils';
import * as _ from 'lodash';
var BookmarksStateDefaults = {
    loading: true,
    exporting: false,
    copying: false,
    saving: false,
    bookmarks: [],
    selectedBookmark: null,
    sort: bookmarkSortRecent,
    checkedBookmarks: [],
    selectedCategory: null
};
var BookmarksState = /** @class */ (function () {
    function BookmarksState(store, storyService, bookmarksService, exploreService, publishService, organizationsService) {
        this.store = store;
        this.storyService = storyService;
        this.bookmarksService = bookmarksService;
        this.exploreService = exploreService;
        this.publishService = publishService;
        this.organizationsService = organizationsService;
    }
    BookmarksState.getBookmarks = function (state) {
        var _a = state.sort, ascending = _a.ascending, field = _a.field, alias = _a.alias;
        // TODO[AC]: get current locale for string comparison
        var collator = new Intl.Collator('en-US', { sensitivity: 'base' });
        return state.bookmarks.sort(function (a, b) {
            var aValue = a[field] || a[alias] || '';
            var bValue = b[field] || b[alias] || '';
            return ((ascending) ? 1 : -1) * collator.compare(aValue, bValue);
        });
    };
    BookmarksState.getCheckedBookmarks = function (state) {
        return state.checkedBookmarks;
    };
    BookmarksState.getSelectedBookmark = function (state) {
        return state.selectedBookmark;
    };
    BookmarksState.getLoading = function (state) {
        return state.loading;
    };
    BookmarksState.getExporting = function (state) {
        return state.exporting;
    };
    BookmarksState.getSaving = function (state) {
        return state.saving;
    };
    BookmarksState.getCopying = function (state) {
        return state.copying;
    };
    BookmarksState.getSort = function (state) {
        return state.sort;
    };
    BookmarksState.getSelectedCategory = function (state) {
        return state.selectedCategory;
    };
    BookmarksState.prototype.loadBookmarks = function (context, action) {
        context.patchState({
            loading: true,
            bookmarks: [],
            checkedBookmarks: []
        });
        // load private content (private bookmarks, custom modules, and favorites)
        forkJoin(this.bookmarksService.getPrivateBookmarks(action.query), this.bookmarksService.getPrivateConditions(), this.bookmarksService.getFavorites())
            .pipe(finalize(function () { context.patchState({ loading: false }); }))
            .subscribe(function (_a) {
            var _b = __read(_a, 3), bookmarks = _b[0], conditions = _b[1], favorites = _b[2];
            context.dispatch(new LoadBookmarksSuccess(__spread(bookmarks, conditions, favorites)));
        });
    };
    BookmarksState.prototype.loadOrganizationBookmarks = function (context, _a) {
        var organizationId = _a.organizationId;
        context.patchState({
            loading: true,
            bookmarks: [],
            checkedBookmarks: []
        });
        // load group content (private bookmarks and custom modules)
        forkJoin(this.bookmarksService.getOrganizationBookmarks(organizationId), this.bookmarksService.getOrganizationConditions(organizationId))
            .pipe(finalize(function () { context.patchState({ loading: false }); }))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), bookmarks = _b[0], conditions = _b[1];
            context.dispatch(new LoadBookmarksSuccess(__spread(bookmarks, conditions)));
        });
    };
    BookmarksState.prototype.loadCollectionBookmarks = function (context, action) {
        context.patchState({
            loading: true,
            bookmarks: [],
            checkedBookmarks: []
        });
        this.organizationsService.getCollectionContent(action.organizationId, action.collectionId)
            .pipe(finalize(function () { context.patchState({ loading: false }); }))
            .subscribe(function (result) {
            context.dispatch(new LoadBookmarksSuccess(result));
        });
    };
    BookmarksState.prototype.loadSuccess = function (_a, action) {
        var patchState = _a.patchState;
        patchState({
            bookmarks: action.result
        });
    };
    BookmarksState.prototype.loadBookmark = function (context, action) {
        var id = action.id, type = action.type;
        var bookmark$ = type === 'bookmark'
            ? this.bookmarksService.getBookmarkModel(id)
            : this.exploreService.getConditionModel(id);
        bookmark$
            .subscribe(function (bookmark) {
            context.dispatch(new SelectBookmarkSuccess(bookmark));
        });
    };
    BookmarksState.prototype.loadBookmarkSuccess = function (context, action) {
        context.patchState({
            selectedBookmark: action.bookmark
        });
    };
    // Replace existing or Save new bookmark
    BookmarksState.prototype.saveBookmark = function (context, action) {
        var _this = this;
        var bookmarkEntry = action.bookmarkEntry;
        // begin save
        context.patchState({ saving: true });
        // requires story
        var serialized;
        if (action.includeIndex) {
            var labels = this.store.selectSnapshot(StoryLabelsState.getLabels);
            var chapters = this.store.selectSnapshot(StoryChaptersState.getStoryChapters);
            this.storyService.storeLabelsInChapters(labels, chapters);
            serialized = this.bookmarksService.createBookmarkStory(action.inplace); // Just a serialized module
            bookmarkEntry.index = serialized.story;
        }
        var method = bookmarkEntry.id ? 'update' : 'save';
        this.bookmarksService.saveBookmark(bookmarkEntry)
            .pipe(finalize(function () {
            context.patchState({ saving: false });
        }))
            .subscribe(function (bookmark) {
            // save thumbnails
            if (action.includeIndex) {
                var thumbnails = _this.store.selectSnapshot(StoryChaptersState.getRegisteredThumbnails);
                context.dispatch(new SaveBookmarkThumbnails(method, bookmark.id, bookmarkEntry, thumbnails, serialized.chapterIdMap));
            }
            // add/remove collections
            if (bookmarkEntry.addCollection || bookmarkEntry.removeCollection) {
                context.dispatch(new UpdateBookmarkCollection(bookmark, bookmarkEntry.addCollection, bookmarkEntry.removeCollection));
            }
            var story = serialized ? serialized.story : null;
            context.dispatch(new SaveBookmarkSuccess(bookmark, story, method));
        }, function (err) {
            context.dispatch(new SaveBookmarkFail(bookmarkEntry));
        });
    };
    BookmarksState.prototype.saveBookmarkSuccess = function (context, action) {
        var savedBookmark = action.bookmark;
        var bookmarks = context.getState().bookmarks;
        // patch bookmark entry
        var savedBookmarkIndex = bookmarks.findIndex(function (bookmark) { return bookmark.id === savedBookmark.id; });
        if (savedBookmarkIndex !== -1) {
            bookmarks[savedBookmarkIndex] = savedBookmark;
            context.patchState({
                bookmarks: __spread(bookmarks)
            });
        }
        // update selected bookmar if replacing (save)
        if (action.method === 'save') {
            context.patchState({
                selectedBookmark: action.bookmark
            });
        }
    };
    BookmarksState.prototype.deleteBookmark = function (context, action) {
        var bookmarkId = action.bookmarkId;
        this.bookmarksService.deleteBookmark(bookmarkId)
            .subscribe(function () {
            context.dispatch(new DeleteBookmarkSuccess(bookmarkId));
        }, function (message) {
            context.dispatch(new DeleteBookmarkFail(bookmarkId, message));
        });
    };
    BookmarksState.prototype.deleteBookmarkSuccess = function (context, action) {
        var bookmarks = context.getState().bookmarks
            .filter(function (bookmark) { return bookmark.id !== action.bookmarkId; });
        context.patchState({
            bookmarks: __spread(bookmarks)
        });
    };
    BookmarksState.prototype.deleteFavorite = function (context, action) {
        var bookmark = action.bookmark;
        var bookmarkId = bookmark.id;
        // category normalization: 'condition' | 'anatomy' | 'bookmark'
        var contentType = _.get(bookmark, 'category', 'bookmark');
        // id normalization
        var contentId = contentType === 'bookmark' ? bookmarkId : this.exploreService.toDatabaseContentId(bookmarkId);
        this.bookmarksService.deleteFavorite(contentId, contentType)
            .subscribe(function () {
            context.dispatch(new DeleteFavoriteSuccess(bookmarkId));
        }, function (err) {
            context.dispatch(new DeleteFavoriteFail(bookmarkId));
        });
    };
    BookmarksState.prototype.deleteFavoriteSuccess = function (context, action) {
        var bookmarks = context.getState().bookmarks
            .filter(function (bookmark) { return bookmark.id !== action.bookmarkId; });
        context.patchState({
            bookmarks: __spread(bookmarks)
        });
    };
    BookmarksState.prototype.sortBookmarks = function (context, action) {
        var bookmarks = context.getState().bookmarks;
        context.patchState({
            sort: action.sort,
            bookmarks: __spread(bookmarks)
        });
    };
    BookmarksState.prototype.clearBookmarks = function (context, action) {
        context.patchState({
            bookmarks: [],
            checkedBookmarks: []
        });
    };
    BookmarksState.prototype.resetBookmarks = function (context, action) {
        context.setState(BookmarksStateDefaults);
    };
    BookmarksState.prototype.checkBookmark = function (context, action) {
        var checkedBookmarks = context.getState().checkedBookmarks;
        var exists = checkedBookmarks.some(function (bookmark) { return bookmark === action.id; });
        if (action.checked && !exists) {
            checkedBookmarks = __spread(checkedBookmarks, [action.id]);
        }
        else if (!action.checked) {
            checkedBookmarks = checkedBookmarks.filter(function (bookmark) { return bookmark !== action.id; });
        }
        context.patchState({
            checkedBookmarks: checkedBookmarks
        });
    };
    BookmarksState.prototype.setCheckedBookmarks = function (context, action) {
        context.patchState({
            checkedBookmarks: action.ids
        });
    };
    BookmarksState.prototype.saveBookmarkThumbnails = function (context, action) {
        var e_1, _a;
        // chapter id mapping (new bookmark chapters have new ids)
        var chapterIdMap = action.chapterIdMap;
        // thumbnail urls on server are identified by story-id and chapter-id.
        var thumbnails = action.thumbnails;
        // replace/create thumbnails
        var requests$ = this.bookmarksService.saveBookmarkThumbnails(action.bookmarkId, action.bookmarkEntry, thumbnails, chapterIdMap);
        // conditionally delete thumbnails
        if (action.method === 'update') {
            // Delete extra thumbnails. We are saving over an existing bookmark
            var deleteRequests$ = this.bookmarksService.deleteBookmarkThumbnails(action.bookmarkId, action.bookmarkEntry, thumbnails, chapterIdMap);
            try {
                for (var deleteRequests$_1 = __values(deleteRequests$), deleteRequests$_1_1 = deleteRequests$_1.next(); !deleteRequests$_1_1.done; deleteRequests$_1_1 = deleteRequests$_1.next()) {
                    var deleteRequest$ = deleteRequests$_1_1.value;
                    requests$.push(deleteRequest$);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (deleteRequests$_1_1 && !deleteRequests$_1_1.done && (_a = deleteRequests$_1.return)) _a.call(deleteRequests$_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        forkJoin(requests$).subscribe(function (results) {
            var thumbnailLookup = action.bookmarkEntry.index.chapters.map(function (chapter) {
                var originalStoryId = action.bookmarkId;
                var newChapterId = chapter.id;
                var originalChapterId = newChapterId;
                return { originalStoryId: originalStoryId, newChapterId: newChapterId, originalChapterId: originalChapterId };
            });
            var _thumbnails = Thumbnail.generateThumbnailUrls(thumbnailLookup);
            // Chapter thumbnails need to be flushed so thumbnails are properly fetched.
            context.dispatch(new RegisterChapterThumbnails(new Map())).subscribe(function () {
                context.dispatch(new RegisterChapterThumbnails(_thumbnails));
            });
        });
    };
    BookmarksState.prototype.exportBookmarks = function (context, action) {
        var bookmarks = action.bookmarks, widgetURL = action.widgetURL, widgetOptions = action.widgetOptions, offlineEnabled = action.offlineEnabled;
        var exportWidgetOptions = widgetOptions || new WidgetOptions();
        var lang = this.store.selectSnapshot(AuthState.getUserLanguage);
        var app = this.store.selectSnapshot(AuthState.getSelectedUserApp);
        context.patchState({ exporting: true });
        this.publishService.exportModels(bookmarks, widgetURL, exportWidgetOptions, null, lang, app, offlineEnabled)
            .pipe(finalize(function () {
            context.patchState({ exporting: false });
        }))
            .subscribe(function (success) {
            if (success) {
                context.dispatch(new ExportBookmarksSuccess(bookmarks));
            }
            else {
                context.dispatch(new ExportBookmarksError(bookmarks));
            }
        });
    };
    BookmarksState.prototype.updateBookmarkCollection = function (context, action) {
        var _this = this;
        var bookmark = action.bookmark, addCollection = action.addCollection, removeCollection = action.removeCollection;
        var collectionContent = {
            content_type: bookmark.type,
            content_id: bookmark.id
        };
        var operations$ = [];
        // #TODO[AC]: service updates to tidy app side bulk updates
        // important: removal need before adding, if applicable
        if (removeCollection) {
            operations$.push(
            // get bookmark's collection content id
            this.organizationsService.getCollectionContentId(removeCollection, collectionContent)
                .pipe(
            // validate id
            filter(function (collectionContentId) { return !!collectionContentId; }), 
            // remove bookmark via collection content id
            flatMap(function (collectionContentId) { return _this.organizationsService.removeFromCollection(removeCollection, [collectionContentId]); }), tap(function () { return context.dispatch(new RemoveBookmarkCollectionSuccess(bookmark, removeCollection)); }, function () { return context.dispatch(new RemoveBookmarkCollectionError(bookmark, removeCollection)); })));
        }
        // optionally: add to collection
        if (addCollection) {
            operations$.push(
            // add content to specified collection
            this.organizationsService.addToCollection(addCollection, [collectionContent])
                .pipe(tap(function () { return context.dispatch(new AddBookmarkCollectionSuccess(bookmark, removeCollection)); }, function () { return context.dispatch(new AddBookmarkCollectionError(bookmark, removeCollection)); })));
        }
        // execute operations
        concat.apply(void 0, __spread(operations$)).subscribe(function () { return context.dispatch(new UpdateBookmarkCollectionSuccess(bookmark, addCollection, removeCollection)); }, function () { return context.dispatch(new UpdateBookmarkCollectionError(bookmark, addCollection, removeCollection)); });
    };
    BookmarksState.prototype.removeBookmarkCollectionSuccess = function (context, action) {
        var _a = context.getState(), bookmarks = _a.bookmarks, selectedCategory = _a.selectedCategory;
        // if current state bookmarks are from collection data: update list
        if (selectedCategory === 'collection') {
            var bookmarkId_1 = action.bookmark.id;
            var patchBookmarks = bookmarks
                .filter(function (bookmark) { return bookmark.id !== bookmarkId_1; });
            context.patchState({
                bookmarks: __spread(patchBookmarks)
            });
        }
    };
    BookmarksState.prototype.copyBookmark = function (context, action) {
        var _this = this;
        var groupAccess = action.groupAccess, collection = action.collection;
        context.patchState({ copying: true });
        this.bookmarksService.copyBookmark(action.id, action.type) // copy bookmark
            .pipe(flatMap(function (id) {
            var operations$ = [of(id)]; // required: bookmark id
            if (groupAccess) { // optional: give group access
                operations$.push(_this.bookmarksService.saveBookmark({ isOwner: true, id: id, add_group_access: [groupAccess] }));
                if (collection) { // optional: add to collection
                    operations$.push(_this.organizationsService.addToCollection(collection, [{ content_type: 'bookmark', content_id: id }]));
                }
            }
            return concat.apply(void 0, __spread(operations$)).pipe(toArray(), map(function () { return id; }));
        }), finalize(function () {
            context.patchState({ copying: false });
        }))
            .subscribe(function (id) {
            context.dispatch(new CopyBookmarkSuccess(id, action.id, groupAccess, collection));
        }, function (error) {
            context.dispatch(new CopyBookmarkFailure(action.id, error));
        });
    };
    BookmarksState.prototype.setBookmarkText = function (context, action) {
        var selectedBookmark = context.getState().selectedBookmark;
        context.patchState({
            selectedBookmark: __assign({}, selectedBookmark, { title: action.title })
        });
    };
    BookmarksState.prototype.setSelectedCategory = function (context, _a) {
        var category = _a.category;
        context.patchState({
            selectedCategory: category ? category : null
        });
    };
    __decorate([
        Action(LoadBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "loadBookmarks", null);
    __decorate([
        Action(LoadOrganizationBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadOrganizationBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "loadOrganizationBookmarks", null);
    __decorate([
        Action(LoadCollectionBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadCollectionBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "loadCollectionBookmarks", null);
    __decorate([
        Action(LoadBookmarksSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, LoadBookmarksSuccess]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "loadSuccess", null);
    __decorate([
        Action(SelectBookmark),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectBookmark]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "loadBookmark", null);
    __decorate([
        Action(SelectBookmarkSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SelectBookmarkSuccess]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "loadBookmarkSuccess", null);
    __decorate([
        Action(SaveBookmark),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SaveBookmark]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "saveBookmark", null);
    __decorate([
        Action(SaveBookmarkSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SaveBookmarkSuccess]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "saveBookmarkSuccess", null);
    __decorate([
        Action(DeleteBookmark),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DeleteBookmark]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "deleteBookmark", null);
    __decorate([
        Action(DeleteBookmarkSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DeleteBookmarkSuccess]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "deleteBookmarkSuccess", null);
    __decorate([
        Action(DeleteFavorite),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DeleteFavorite]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "deleteFavorite", null);
    __decorate([
        Action(DeleteFavoriteSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, DeleteFavoriteSuccess]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "deleteFavoriteSuccess", null);
    __decorate([
        Action(SortBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SortBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "sortBookmarks", null);
    __decorate([
        Action(ClearBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ClearBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "clearBookmarks", null);
    __decorate([
        Action(ResetBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ResetBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "resetBookmarks", null);
    __decorate([
        Action(CheckBookmark),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CheckBookmark]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "checkBookmark", null);
    __decorate([
        Action(SetCheckedBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetCheckedBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "setCheckedBookmarks", null);
    __decorate([
        Action(SaveBookmarkThumbnails),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SaveBookmarkThumbnails]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "saveBookmarkThumbnails", null);
    __decorate([
        Action(ExportBookmarks),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, ExportBookmarks]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "exportBookmarks", null);
    __decorate([
        Action(UpdateBookmarkCollection),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, UpdateBookmarkCollection]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "updateBookmarkCollection", null);
    __decorate([
        Action(RemoveBookmarkCollectionSuccess),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, RemoveBookmarkCollectionSuccess]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "removeBookmarkCollectionSuccess", null);
    __decorate([
        Action(CopyBookmark),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, CopyBookmark]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "copyBookmark", null);
    __decorate([
        Action(SetBookmarkText),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetBookmarkText]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "setBookmarkText", null);
    __decorate([
        Action(SetSelectedCategory),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, SetSelectedCategory]),
        __metadata("design:returntype", void 0)
    ], BookmarksState.prototype, "setSelectedCategory", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getBookmarks", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getCheckedBookmarks", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getSelectedBookmark", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getLoading", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getExporting", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getSaving", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getCopying", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getSort", null);
    __decorate([
        Selector(),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [BookmarksStateModel]),
        __metadata("design:returntype", void 0)
    ], BookmarksState, "getSelectedCategory", null);
    BookmarksState = __decorate([
        State({
            name: 'bookmarks',
            defaults: BookmarksStateDefaults
        }),
        __metadata("design:paramtypes", [Store,
            StoryService,
            BookmarksService,
            ExploreService,
            PublishService,
            OrganizationsService])
    ], BookmarksState);
    return BookmarksState;
}());
export { BookmarksState };
